<template>
  <div id="content" class="sections">
    <Head>
      <!-- Primary Meta Tags -->
      <title>{{ changeMetatagHtml($t("bateriesSystem12V.metaTitle")) }}</title>

      <link rel="canonical" href="https://komatools.com/es/sistema-de-baterias-intercambiables-20v"/>
      <link rel="alternate" href="https://komatools.com/es/sistema-de-baterias-intercambiables-20v" hreflang="es"/>
      <link rel="alternate" href="https://komatools.com/en/interchangeable-battery-system" hreflang="en"/>
      <link rel="alternate" href="https://komatools.com/fr/systeme-de-batterie-interchangeable" hreflang="fr"/>
      <link rel="alternate" href="https://komatools.com/es/sistema-de-baterias-intercambiables-20v"
            hreflang="x-default"/>

      <meta name="title" :content="changeMetatagHtml($t('bateriesSystem12V.metaTitle'))">

      <meta name="description" :content="$t('bateriesSystem12V.metaDescription')">

      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website">
      <meta property="og:url" content="https://komatools.com/">
      <meta property="og:title" :content="changeMetatagHtml($t('bateriesSystem12V.metaTitle'))">
      <meta property="og:description" :content="$t('bateriesSystem12V.metaDescription')">
      <meta property="og:image" content="https://komatools.com/img/komatoolsSocial.jpg">

      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image">
      <meta property="twitter:url" content="https://komatools.com/">
      <meta property="twitter:title" :content="changeMetatagHtml($t('bateriesSystem12V.metaTitle'))">
      <meta property="twitter:description" :content="$t('bateriesSystem12V.metaDescription')">
      <meta property="twitter:image" content="https://komatools.com/img/komatoolsSocial.jpg">
    </Head>
    <div class="section paddingBigger light verticallyCentered">
      <div>
        <div class="banner cetered">
          <div class="header">
            <h1 class="title huge">{{ $t('bateriesSystem12V.title1') }}</h1>
            <h1 class="title">{{ $t('bateriesSystem12V.title2') }}</h1>
            <h2 v-html="$t('bateriesSystem12V.subTitle')" class="subTitle"></h2>
          </div>
          <div class="description" v-html="$t('bateriesSystem12V.description')"></div>
          <div class="cta">{{ $t('bateriesSystem12V.cta1') }}</div>
          <div style="display: flex;justify-content: center;width: 100%;padding: 10px 0;">
            <img src="@/assets/img/bateries-system/12v/12V.svg" alt="12 V ONE FOR ALL Compact Battery System"
                 style="max-width: 300px;">
          </div>

        </div>
      </div>
    </div>
    <div class="section dark paddingHuge photoBackground double verticallyCentered" id="backgroundBateriesSystem4V12">
      <div>
        <div class="tryptych">

        </div>
        <div class="banner">
          <div class="header">
            <h2 class="title">{{ $t('bateriesSystem12V.cta2') }}</h2>
          </div>
          <div v-html="$t('bateriesSystem12V.textCta2')" class="description"></div>
        </div>

      </div>
    </div>
    <div class="section paddingBigger light">
        <div class="banner">
          <div class="header">
            <h2 class="title">{{ $t('bateriesSystem12V.cta3') }}</h2>
          </div>
        </div>
    </div>
    <div class="section paddingBigger light double verticallyCentered">
      <div>
        <img src="@/assets/img/bateries-system/12v/batteryComposition.png"
             :alt="$t('bateriesSystem12V.cta3')+' | '+$t('bateriesSystem12V.firstCard.title')+' | '+$t('bateriesSystem12V.secondCard.title')+' | '+$t('bateriesSystem12V.thirdCard.title')">
        <div class="list">
          <div class="item">
            <div class="icon go"></div>
            <div class="title">{{ $t('bateriesSystem12V.bateriesCharacteristics.characteristic1.title') }}</div>
            <div class="text">{{ $t('bateriesSystem12V.bateriesCharacteristics.characteristic1.text') }}</div>
          </div>
          <div class="item">
            <div class="icon go"></div>
            <div class="title">{{ $t('bateriesSystem12V.bateriesCharacteristics.characteristic2.title') }}</div>
            <div class="text">{{ $t('bateriesSystem12V.bateriesCharacteristics.characteristic2.text') }}</div>
          </div>
          <div class="item">
            <div class="icon go"></div>
            <div class="title">{{ $t('bateriesSystem12V.bateriesCharacteristics.characteristic3.title') }}</div>
            <div class="text">{{ $t('bateriesSystem12V.bateriesCharacteristics.characteristic3.text') }}</div>
          </div>
          <div class="item">
            <div class="icon go"></div>
            <div class="title">{{ $t('bateriesSystem12V.bateriesCharacteristics.characteristic4.title') }}</div>
            <div class="text">{{ $t('bateriesSystem12V.bateriesCharacteristics.characteristic4.text') }}</div>
          </div>
          <div class="item">
            <div class="icon go"></div>
            <div class="title">{{ $t('bateriesSystem12V.bateriesCharacteristics.characteristic5.title') }}</div>
            <div class="text">{{ $t('bateriesSystem12V.bateriesCharacteristics.characteristic5.text') }}</div>
          </div>
          <div class="item">
            <div class="icon go"></div>
            <div class="title">{{ $t('bateriesSystem12V.bateriesCharacteristics.characteristic6.title') }}</div>
            <div class="text">{{ $t('bateriesSystem12V.bateriesCharacteristics.characteristic6.text') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section light paddingBigger">
      <div>
        <div class="cards">
          <div class="card">
            <img src="@/assets/icons/toolbox.svg" :alt="$t('bateriesSystem12V.firstCard.title')">
            <div class="text"><b>{{ $t('bateriesSystem12V.firstCard.title') }}</b></div>
            <div v-html="$t('bateriesSystem12V.firstCard.text')" class="description"></div>
          </div>
          <div class="card">
            <img src="@/assets/icons/ecologic.svg" :alt="$t('bateriesSystem12V.firstCard.title')">
            <div class="text"><b>{{ $t('bateriesSystem12V.secondCard.title') }}</b></div>
            <div v-html="$t('bateriesSystem12V.secondCard.text')" class="description"></div>
          </div>
          <div class="card">
            <img src="@/assets/icons/battery.svg" :alt="$t('bateriesSystem12V.firstCard.title')">
            <div class="text"><b>{{ $t('bateriesSystem12V.thirdCard.title') }}</b></div>
            <div v-html="$t('bateriesSystem12V.thirdCard.text')" class="description"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="section dark narrowLeft paddingHuge photoBackground lightPhoto" id="backgroundBateriesSystem1V12">
      <div>
        <div class="banner centered">
          <div class="header">
            <h2 class="title" v-html="$t('bateriesSystem12V.cta4')" style="white-space: nowrap;"></h2>
          </div>
          <div v-html="$t('bateriesSystem12V.firstTextCta4')" class="description"></div>
          <div v-html="$t('bateriesSystem12V.secondTextCta4')" class="description"></div>
        </div>
      </div>
    </div>
    <div class="section paddingBigger light">
      <div>
        <div class="banner centered" style="width: 100%;">
          <div class="header">
            <h2 class="title">{{ $t('bateriesSystem12V.cta5') }}</h2>
          </div>
        </div>
        <div class="panelButtons">
          <div class="panelButton">
            <div class="texts">
              <div v-html="$t('bateriesSystem12V.firstPanel.title')" class="text"></div>
              <LocalizedLink class="button accent" :to="$t('routes.initialKits') + $t('filterRoutes.starterKits12v')">
                <div class="text">{{ $t("bateriesSystem12V.firstPanel.buttonName") }}</div>
                <div class="icon go"></div>
              </LocalizedLink>
            </div>
            <div class="photo" id="backgroundBateriesSystem2V12"></div>
          </div>

          <div class="panelButton">
            <div class="texts">
              <div v-html="$t('bateriesSystem12V.secondPanel.title')" class="text"></div>
              <LocalizedLink class="button accent" :to="$t('routes.oneForAllTools') + $t('filterRoutes.oneForAll12v')">
                <div class="text">{{ $t("bateriesSystem12V.secondPanel.buttonName") }}</div>
                <div class="icon go"></div>
              </LocalizedLink>
            </div>
            <div class="photo" id="backgroundBateriesSystem3V12"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LocalizedLink from "@/components/LocalizedLink.vue"
import {Head} from '@vueuse/head'


export default {
  components: {LocalizedLink, Head},
  setup() {
    /**
     * This is a function to remove the special character | from javascript
     * More information: https://stackoverflow.com/questions/5796718/html-entity-decode
     */
    const changeMetatagHtml = (html) => {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;

    }
    return {changeMetatagHtml}
  },
}
</script>


<style>
.banner .header > .subTitle {
  line-height: 1.3em !important;
}

.cards > .card {
  max-width: 300px;
}

#backgroundBateriesSystem1V12 {
  background-image: url('@/assets/img/bateries-system/12v/backgroundBateriesSystem1.jpeg');
}

#backgroundBateriesSystem2V12 {
  background-image: url('@/assets/img/bateries-system/12v/1.jpg');
  background-position-y: 90%;
}

#backgroundBateriesSystem3V12 {
  background-image: url('@/assets/img/bateries-system/12v/2.jpg');
}

#backgroundBateriesSystem4V12 {
  background-image: url('@/assets/img/bateries-system/12v/background_section2.png');
  background-position: right;
  background-position-x: 25%;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
